module.exports = __webpack_public_path__ + "img/52114112_L.3b021f46.png";